import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../contexts/LanguageContext";
import api from "../../lib/api";
import { ArrowRight, MapPin, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Saved() {
  const { t, lang } = useI18n();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { const r = await api.get("/saved-jobs"); setJobs(r.data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    try { await api.delete(`/saved-jobs/${id}`); setJobs((js) => js.filter((j) => j.job_id !== id)); }
    catch { toast.error("Error"); }
  };

  return (
    <div className="container-pad mx-auto max-w-[1200px] py-12" data-testid="page-saved">
      <h1 className="text-3xl font-extrabold text-navy">{t.dash.saved}</h1>
      {loading ? (
        <div className="py-20 text-center text-slate-500">{t.common.loading}</div>
      ) : jobs.length === 0 ? (
        <div className="py-20 text-center text-slate-500" data-testid="saved-empty">{t.dash.noSaved}</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          {jobs.map((j) => (
            <div key={j.job_id} className="bg-white border border-slate-100 rounded-[24px] p-6 hover:shadow-xl transition-shadow" data-testid={`saved-card-${j.job_id}`}>
              <div className="text-xs uppercase tracking-widest text-slate-500">{j.category} · {j.type}</div>
              <h3 className="mt-2 text-lg font-bold text-navy">{j.title[lang] || j.title.en}</h3>
              <div className="text-sm text-slate-600">{j.company}</div>
              <div className="mt-3 inline-flex items-center gap-1 text-sm text-slate-600"><MapPin size={14} /> {j.location}</div>
              <div className="mt-5 flex justify-between items-center">
                <Link to={`/job/${j.job_id}`} className="inline-flex items-center gap-1 text-navy font-semibold hover:text-brandred">{t.jobs.details} <ArrowRight size={14} /></Link>
                <button onClick={() => remove(j.job_id)} className="text-slate-500 hover:text-brandred" data-testid={`remove-${j.job_id}`}><Trash2 size={16} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
